import { render, staticRenderFns } from "./BrandListItem.vue?vue&type=template&id=f90e58b4&scoped=true&"
import script from "./BrandListItem.vue?vue&type=script&lang=ts&"
export * from "./BrandListItem.vue?vue&type=script&lang=ts&"
import style0 from "./BrandListItem.vue?vue&type=style&index=0&id=f90e58b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90e58b4",
  null
  
)

export default component.exports